/**
 * @generated SignedSource<<b1eec08a1b9cd2f19b712f2fe945c8db>>
 * @relayHash 3a2c90542de719ac05d9234999cdbf6a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8c4f567c86a7d3ab3c313ddb063766710ea036f75f9aebef277cfcde84b5aacb

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PopupContentQuery } from './PopupContentQuery.graphql';

const node: PreloadableConcreteRequest<PopupContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8c4f567c86a7d3ab3c313ddb063766710ea036f75f9aebef277cfcde84b5aacb",
    "metadata": {},
    "name": "PopupContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
